import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { BaseProvider } from '../providers/base-provider';

@Injectable()
export class ConsumerTimelineProvider extends BaseProvider {
	timeline: any[] = []

	constructor(		
		public http: Http,	
		public globals: Globals,
		public storage: Storage,
		public httpHelper: HttpHelper) {
		super();
	}

  	getTimeline(params){	
	  	this.url = this.globals.dataUrl + 'consumerMessage/whiskey/' + this.globals.whiskeyId + '/timeline/page/' + params.page + '/size/' + params.size;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(
		    	res => {
		    		if(params.page==1){
		    			this.timeline = res.Data;
		    		}else{
		    			for (var i = 0; i < res.Data.length; i++) {			
							this.list.push(res.Data[i]);
						}
		    		}
		    		
		        	if(typeof params.cb == "function") params.cb(res.Data);
		    	}
		    );   
    	})
  	}

  	getBusinessTimeline(businessId, params){	
	  	this.url = this.globals.dataUrl + 'consumerMessage/timeline/businessId/'+ businessId + '/page/' + params.page + '/size/' + params.size;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(
		    	res => {
		    		if(params.page==1){
		    			this.list = res.Data;
		    		}else{
		    			this.pushItems(res.Data);	
		    		}
		    		
		        	if(typeof params.cb == "function") params.cb(this.list);
		    	}
		    );   
    	})
  	}
}



// WEBPACK FOOTER //
// ./src/providers/consumer-timeline-handler.ts